import { StyleSheet } from 'react-native';

export default StyleSheet.create({
    backToTopBtn: {
        position: 'absolute',
        right: 10,
        bottom: 60,
        justifyContent: 'center',
        alignItems: 'center',
        width: 43,
        height: 43,
        borderWidth: 1,
        borderColor: '#ddd',
        borderRadius: 21,
        backgroundColor: 'rgba(255, 255, 255, 0.8)'
    },
    backToTopBtnIcon: {
        width: 20,
        height: 20,
        lineHeight: 20,
        color: '#ccc',
        backgroundColor: 'rgba(255, 255, 255, 0.8)'
    }
});
